export const canMove = (movableRange: number[], order: number): { up: boolean; down: boolean } | false => {
  if (movableRange.length <= 1) {
    return false;
  }
  if (!movableRange.includes(order)) {
    return false;
  }
  return { up: order > movableRange.at(0)!, down: order < movableRange.at(-1)! };
};
